module.exports = __webpack_public_path__ + "static/header.9420cf9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SpeakerSections/header.svg
// module id = 711
// module chunks = 195234328731080